import { Link } from 'react-router-dom';
import type { EventItem } from '@/types/content';
import { formatDate } from '@/utils/date';
import FavoriteButton from './FavoriteButton';

const STATUS_STYLES: Record<string, { label: string; className: string }> = {
  ongoing: { label: '进行中', className: 'bg-accent-500 text-background-50' },
  upcoming: { label: '即将开启', className: 'bg-primary-500 text-background-50 dark:text-foreground-950' },
  ended: { label: '已结束', className: 'bg-secondary-500 text-background-50' },
};

export default function EventCard({ item }: { item: EventItem }) {
  const status = STATUS_STYLES[item.status] ?? STATUS_STYLES.upcoming;

  return (
    <article className="gs-card-hover group flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50">
      <Link to={`/events/${item.id}`} className="block cursor-pointer">
        <div className="relative h-48 w-full overflow-hidden">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} 原神活动`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
          <span className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-label ${status.className}`}>{status.label}</span>
          <div className="absolute bottom-3 left-3 right-3">
            <h3 className="font-heading text-lg font-bold text-background-50">{item.title}</h3>
          </div>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4">
        <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {formatDate(item.start)} 至 {formatDate(item.end)}
          </span>
        </div>
        <p className="mt-2.5 line-clamp-2 flex-1 text-sm text-foreground-600">{item.intro}</p>

        <div className="mt-3 rounded-lg bg-accent-50 p-2.5">
          <p className="flex items-start gap-1.5 text-xs text-accent-800">
            <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
              <i className="ri-gift-line"></i>
            </span>
            {item.reward}
          </p>
        </div>

        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3">
          <div className="flex flex-wrap gap-1.5">
            {item.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                {tag}
              </span>
            ))}
          </div>
          <FavoriteButton id={`event-${item.id}`} />
        </div>
      </div>
    </article>
  );
}